import { AppState } from '../../bootstrap/redux/state/AppState';
import { IUserSettings } from '../models/IUserSettings';

export function selectUserSettings(state: AppState, domainName: string, userName: string): IUserSettings {
  return state.userSettings[domainName] ? state.userSettings[domainName][userName] : undefined;
}